"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMobile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.1 0H302.9C216.4 0 146 71.3 146 158.9v706.2c0 87.6 70.4 158.9 156.9 158.9h418.2c86.5 0 156.9-71.3 156.9-158.9V158.9C878 71.3 807.6 0 721.1 0zm122 865.1c0 68.1-54.7 123.6-122 123.6H302.9c-67.3 0-122-55.4-122-123.6v-17.7h662.2v17.7zm0-53H180.9V211.9h662.2v600.2zm0-635.5H181v-17.7c0-68.1 54.7-123.6 122-123.6h418.2c67.3 0 122 55.4 122 123.6v17.7zm-221.9-73.8c0 10-8.2 18.2-18.2 18.2H421c-10 0-18.2-8.2-18.2-18.2S411 84.6 421 84.6h182c10.1 0 18.2 8.2 18.2 18.2zM475.6 916.9c0-20.1 16.3-36.4 36.4-36.4 20.1 0 36.4 16.3 36.4 36.4s-16.3 36.4-36.4 36.4c-20.1 0-36.4-16.3-36.4-36.4z"
  }));
}

var ForwardRef = React.forwardRef(SvgMobile);
var _default = ForwardRef;
exports.default = _default;